module.exports = __webpack_public_path__ + "static/media/more.d3ce8c41.svg";